import ApplicationUpdateBanner from '@Guidelines/Shell/ApplicationUpdateBanner';
import CaptureActivityHost from '@Guidelines/Shell/CaptureActivityHost';
import InstallAppBanner from '@Guidelines/Shell/InstallAppBanner';
import InterruptedRecordingNotice from '@Guidelines/Shell/InterruptedRecordingNotice';
import PullToRefresh from '@Guidelines/Shell/PullToRefresh';
import * as React from 'react';

/**
 * Groups the application-wide overlays (banners, pull-to-refresh) and the capture-activity host, and
 * mounts them once, above the routed pages: `RootPage` mounts several times over and nests within
 * itself across the tree, so placing overlays inside it would render them once per nested instance.
 */
const ApplicationOverlays: React.FC = () => {
	return (
		<React.Fragment>
			<CaptureActivityHost />
			<ApplicationUpdateBanner />
			<InterruptedRecordingNotice />
			<InstallAppBanner />
			<PullToRefresh />
		</React.Fragment>
	);
};

export default ApplicationOverlays;
